import { ExclamationTriangleIcon, InfoCircledIcon } from '@radix-ui/react-icons'
import { Flex, Link } from '@radix-ui/themes'
import { SOLANA_NETWORK } from 'app/solana-config'
import { RECOMMENDED_SOL_BALANCE } from 'solana-bc/sol-fee'
import styles from '../neon-wallets.module.scss'

const DEVNET_FAUCET_URL = 'https://faucet.solana.com'

/** What to send and how: the network fee is paid in SOL by the user. */
export const DepositNotes: React.FC = () => (
  <Flex
    direction='column'
    gap='2'
  >
    <span className={styles.depositNote}>
      <InfoCircledIcon />
      <span>
        SOL pays the network fee of every bet. Keep at least{' '}
        {RECOMMENDED_SOL_BALANCE} SOL in this wallet. USDT is the token you play
        with.
      </span>
    </span>
    <span
      className={styles.depositNote}
      data-tone='orange'
    >
      <ExclamationTriangleIcon />
      <span>
        Send on the Solana network only. Tokens sent from another network, or
        other tokens, can be lost.
      </span>
    </span>
    {SOLANA_NETWORK === 'mainnet-beta' ? null : (
      <span
        className={styles.depositNote}
        data-tone='muted'
      >
        <InfoCircledIcon />
        <span>
          This is a test stand on Solana {SOLANA_NETWORK}: send test SOL and the
          test USDT only. Free devnet SOL:{' '}
          <Link
            href={DEVNET_FAUCET_URL}
            target='_blank'
            rel='noreferrer'
          >
            faucet.solana.com
          </Link>
        </span>
      </span>
    )}
  </Flex>
)
